/**
 * 国际化配置文件
 * SC:中文
 * TC:繁体
 */
export default {
    sysManagement: { SC:"系统管理", TC: "系統管理" , EN: "Sytem" }
    ,update: { SC:"修改", TC: "修改", EN: "Edit" }
    ,delete: { SC:"删除", TC: "刪除", EN: "Delete" }
    ,audit: { SC:"日志", TC: "日誌", EN: "Log" }
    ,selectiveData: { SC:"请选择一条数据", TC: "請選擇一條數據", EN: "Please select a reord." }
    ,deleteData: { SC:"数据删除中...", TC: "數據删除中...", EN: "Data is processing..." }
    ,deleteSuccess: { SC:"删除成功", TC: "刪除成功", EN: "Deleted successfully." }
    ,beQuerying: { SC:"查询中...", TC: "査詢中...", EN: "Searching..." }
    ,noneDate: { SC:"找不到符合条件记录.", TC: "找不到符合f條件記錄.", EN: "No record is founed." }
    ,saveSuccess: { SC:"保存成功", TC: "保存成功", EN: "Saved successfully." }
    ,controls: { SC:"操作", TC: "操作", EN: "Operation" }
    ,list: { SC:"列表", TC: "列表", EN: "List" }
    ,search: { SC:"查询", TC: "査詢", EN: "Search" }
    ,reset: { SC:"重置", TC: "重置", EN: "Reset" }
    ,add: { SC:"新增", TC: "新增", EN: "Add" }
    ,save: { SC:"保存", TC: "保存", EN: "Save" }
    ,cancel: { SC:"取消", TC: "取消", EN: "Cancel" }
    ,dataBeSaving: { SC:"数据保存中...", TC: "數據保存中...", EN: "Data is processing..." }
   ,mailNotifications: { SC:"Email Template", EN: "Email Template" }
   ,templateCode: { SC:"模板编号", EN: "Email Template Code" }
   ,templateName: { SC:"模板名称", EN: "Email Template Name" }
   ,templateType: { SC:"模板类型", EN: "Email Template Description" }
   ,activeInd: { SC:"激活状态", EN: "Status" }
   ,seq: { SC:"序号", EN: "Seq" }
   ,templateCodeNoIsNull: { SC:"模板编号不能为空", EN: "Email Template Code is required." }
   ,templateNameNoIsNull: { SC:"模板名称不能为空", EN: "Email Template Name is required." }
   ,templateTypeNoIsNull: { SC:"模板类型不能为空", EN: "Email Template Description is required." }
   ,seqNoIsNull: { SC:"序号不能为空", EN: "Seq is required." }
   ,activeIndNoIsNull: { SC:"激活状态不能为空", EN: "Status is required." }
   ,content: { SC:"内容", EN: "Content" }

}